export default __webpack_public_path__ + "static/media/Punjabi-Kada.2e9ef3e1.jpg";